/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardOrderItemResponseViewModel } from "../types/CreditCardOrderItemResponseViewModel.ts";

export const creditCardOrderItemResponseViewModelSchema = z.object({
  quantity: z.optional(z.number().int()),
  description: z.string().nullish(),
  value: z.optional(z.number()),
  percentageDiscount: z.number().nullish(),
  currency: z.string().nullish(),
}) as unknown as ToZod<CreditCardOrderItemResponseViewModel>;
